import React from 'react';
import { Edit, SaveButton, SelectInput, SimpleForm, TextInput, Toolbar, required } from 'react-admin';
import { CustomDateInput } from '../../../../commonComponents/CustomDateInput';
import ImageInput from '../../../../commonComponents/UploadInputs/ImageInput';
import { s3FilePaths } from '../../../../config/constants';

const difficultyChoices = [
  { id: 'easy', name: 'Easy' },
  { id: 'hard', name: 'Hard' },
];

const JigsawEventsEditToolbar = (props) => (
  <Toolbar {...props}>
    <SaveButton />
  </Toolbar>
);

const JigsawEventsEditFields = ({ record, ...rest }) => {
  const today = new Date().toISOString().split('T')[0];
  const isTodayEvent = record?.date === today;
  const isPastEvent = record && record.date < today;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', alignItems: 'start' }}>
      <TextInput label="Id" source="id" disabled />
      <CustomDateInput
        label="Date"
        source="date"
        validate={required()}
        disabled={isTodayEvent || isPastEvent}
        {...rest}
      />
      <SelectInput
        source="difficulty"
        label="Difficulty"
        choices={difficultyChoices}
        validate={required()}
        disabled={isPastEvent}
        {...rest}
      />
      <ImageInput
        imagePath={s3FilePaths.figureGame}
        imageInputSource="image_file_key"
        label="Puzzle image"
        validate={required()}
        helperText="Recommended aspect ratio: 3:4"
        disabled={isPastEvent}
        {...rest}
      />
    </div>
  );
};

const JigsawEventsEdit = (props) => (
  <Edit undoable={false} {...props}>
    <SimpleForm toolbar={<JigsawEventsEditToolbar />}>
      <JigsawEventsEditFields />
    </SimpleForm>
  </Edit>
);

export default JigsawEventsEdit;
